import { useEffect, useMemo, useState } from "react";
import { useKarunaPageSize } from "@/project/karuna/hooks/useKarunaPageSize";

export function useKarunaPagedList<T>(items: T[], ...resetDeps: unknown[]) {
  const { pageSize, setPageSize } = useKarunaPageSize();
  const [page, setPage] = useState(1);

  const totalPages = useMemo(() => {
    if (items.length === 0) {
      return 1;
    }
    return Math.ceil(items.length / pageSize);
  }, [items.length, pageSize]);

  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset page when filter deps change
  }, resetDeps);

  useEffect(() => {
    setPage(1);
  }, [pageSize]);

  useEffect(() => {
    setPage(p => Math.min(Math.max(1, p), totalPages));
  }, [totalPages]);

  const paginatedItems = useMemo(() => {
    const p = Math.min(Math.max(1, page), totalPages);
    const start = (p - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, page, totalPages, pageSize]);

  return {
    page,
    setPage,
    totalPages,
    paginatedItems,
    totalItems: items.length,
    pageSize,
    setPageSize,
  };
}
